export function getDigiwiseAccountBaseUrl(): string {
  const envUrl = (import.meta as unknown as { env: { VITE_DIGIWISE_ACCOUNT_URL?: string } }).env
    .VITE_DIGIWISE_ACCOUNT_URL;
  if (envUrl?.trim()) return envUrl.trim().replace(/\/$/, '');
  const mode = (import.meta as unknown as { env: { MODE?: string } }).env.MODE;
  return mode === 'production' ? 'https://account.digiwise.ir' : 'https://account.digiwise.tech';
}
